import HeaderBar from "./common/HeaderBar";
import FooterBar from "./common/FooterBar";
import React, { Component } from "react";
import "../style/contact.scss";
import EmailFill from "../icon/EmailFill";

class ContacUs extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount(){
    window.scrollTo(0,0)
  }

  render() {
    return (
      <React.Fragment>
        <HeaderBar {...this.props} />
        <div className="contact-page">
          <div className="contact-content">
            <div className="left"></div>
            <div className="right">
              <h1>How can I contact Folksy?</h1>
              <p>
                Folksy is a place to buy hand crafted gifts and handmade or
                commercial supplies. When you buy an item through Folksy, you
                buy directly from one of thousands of UK based designers and
                sellers.{" "}
              </p>
              <p>
                <b>
                  For enquiries about an item you are interested in buying, or
                  about an order that you have placed, please CONTACT THE SELLER
                  in the first instance.
                </b>
              </p>
              <p>
                <b>Enquiries about an item/product for sale</b>
              </p>
              <p>CONTACT THE SELLER</p>
              <p>To ask about a particular product or its availability</p>
              <p>
                To send a message relating to a potential order such as a
                preference for size or colour
              </p>
              <p>To ask about a custom item</p>
              <p>
                Please note that you will need to be registered with Folksy and
                logged in to do so.
              </p>
              <p>
                If you contact Folksy admin, your enquiry will take longer to
                resolve as we will need to forward your enquiry to the seller.
                However, if your order hasn't arrived and if the seller is not
                responding please contact us for help.{" "}
              </p>
              <p>
                <b>Questions about your order</b>
              </p>
              <p>CONTACT THE SELLER</p>
              <p>To make any changes to your order</p>
              <p>
                To ask about postage or when the order is expected to be
                delivered
              </p>
              <p>If you order hasn't arrived</p>
              <p>Problems with your order or items</p>
              <p>Organise a return, refund or replacement</p>
              <p>
                Please email the seller directly and they will be able to help
                you. You will have received a confirmation email containing the
                seller's email address when you placed your order on Folksy. The
                email address will be in the body of the text.
              </p>
              <p>
                If you contact Folksy admin, your enquiry will take longer to
                resolve as we will need to forward your enquiry to the seller.
                However, if your order hasn't arrived and if the seller is not
                responding please contact us for help.{" "}
              </p>
            </div>
          </div>
        </div>
        <FooterBar {...this.props} />
      </React.Fragment>
    );
  }
}

export default ContacUs;
